// authSlice.js
import { createSlice } from "@reduxjs/toolkit";
//import Cookies from 'js-cookie';


const storedAuthData = JSON.parse(localStorage.getItem("authData")) || null;

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: storedAuthData ? storedAuthData.user : null,
    token: storedAuthData ? storedAuthData.accessToken : null,
    refreshToken: storedAuthData ? storedAuthData.refreshToken : null,
    role: storedAuthData ? storedAuthData.role : null,
    organization: storedAuthData ? storedAuthData.organization : null,
  },
  reducers: {
    setCredentials: (state, action) => {
      const { user, accessToken, refreshToken } = action.payload;
      state.user = user;
      state.token = accessToken;
      state.refreshToken = refreshToken
      if (user) {
        state.role = user.role; // Add a check to ensure user is not null or undefined
        state.organization = user.organization;
      } else {
        state.role = null;
        state.organization = null;
      }
      //Cookies.set('accessToken', accessToken, { expires: 7, secure: true });
      localStorage.setItem("authData", JSON.stringify(action.payload));
    },
    logOut: (state, action) => {
      state.user = null;
      state.token = null;
      state.role = null;
      state.organization = null;
      localStorage.removeItem("authData");
    }
  },
});


export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentToken = (state) => state.auth.token;
export const selectRefreshToken = (state) => state.auth.refreshToken;
